// ============================================================
// Alpine: shopCart — halaman keranjang
// ============================================================

import Alpine from 'alpinejs';
import axios from '../../config/axios.js';
import { requireAuth, shopApi } from '../../helpers/shopAuth.js';

export function registerShopCart() {
  Alpine.data('shopCart', () => ({
    items: [],
    summary: null,
    loading: true,
    updating: null,
    error: '',
    galleryOpen: false,
    galleryProduct: null,
    galleryItems: [],
    galleryActive: 0,

    init() {
      if (!requireAuth('/shop/cart')) return;
      this.fetchCart();
    },

    formatRp(n) {
      return window.formatRupiah ? window.formatRupiah(n) : `Rp ${Number(n).toLocaleString('id-ID')}`;
    },

    productThumb(item) {
      const gallery = item.product?.gallery || [];
      const firstPhoto = gallery.find((g) => g.type === 'photo') || gallery[0];
      if (firstPhoto?.thumbnail_url || firstPhoto?.url) {
        return firstPhoto.thumbnail_url || firstPhoto.url;
      }
      if (item.product?.image) {
        return item.product.image;
      }
      const slug = item.product?.slug;
      return slug ? `/assets/images/products/${slug}.png` : '/images/placeholder-product.png';
    },

    openGallery(item) {
      const gallery = item.product?.gallery || [];
      if (!gallery.length) return;
      this.galleryProduct = item.product;
      this.galleryItems = gallery;
      this.galleryActive = 0;
      this.galleryOpen = true;
    },

    async fetchCart() {
      this.loading = true;
      this.error = '';
      try {
        const { data } = await axios.get(shopApi('/cart'));
        this.items = data.data?.items || [];
        this.summary = data.data?.summary || null;
        Alpine.store('cart').setCount(this.items.length);
      } catch (e) {
        this.error = e.response?.data?.message || 'Gagal memuat keranjang.';
      } finally {
        this.loading = false;
      }
    },

    async updateQty(item, delta) {
      const min = item.product?.min_order || 1;
      const newQty = Math.max(min, item.qty + delta);
      if (newQty === item.qty) return;

      this.updating = item.id;
      try {
        await axios.put(shopApi(`/cart/${item.id}`), { qty: newQty });
        await this.fetchCart();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memperbarui qty.', 'error');
      } finally {
        this.updating = null;
      }
    },

    async removeItem(itemId) {
      const ok = await window.confirmDialog({
        title: 'Hapus Item?',
        message: 'Hapus item dari keranjang?',
        confirmText: 'Ya, Hapus',
        cancelText: 'Batal',
        variant: 'danger',
      });
      if (!ok) return;

      try {
        await axios.delete(shopApi(`/cart/${itemId}`));
        await this.fetchCart();
        window.toast?.('Item dihapus', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus item.', 'error');
      }
    },

    goCheckout() {
      if (!this.items.length) return;
      if (!requireAuth('/shop/checkout')) return;
      window.location.href = '/shop/checkout';
    },
  }));
}
